var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    {
      staticClass: "filter-pill",
      class: [
        _vm.isActive ? "active" : "pending",
        _vm.isStatic ? "static" : "",
      ],
      on: { click: _vm.remove },
    },
    [
      !_vm.isStatic
        ? _c("i", {
            staticClass: "fa fa-times-circle",
            attrs: { "aria-hidden": "true" },
          })
        : _vm._e(),
      _vm._v(" " + _vm._s(_vm.name)),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }